import React, { Dispatch, SetStateAction } from 'react';

import { Box } from '@chakra-ui/react';
import { Button } from '@mesh.ai/rabbit';

import CheckInSuccessIllustration from 'assets/assetsV1/illustrations/deerIllustrations/checkInSuccess.svg';

import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';
import { TextHeader1 } from 'uiToolkitV1/Typography';

const Heading = () => (
  <Box display="flex" justifyContent="center" alignItems="center" marginBottom="16px" width="100%">
    <TextHeader1 fontSize="20px" lineHeight="32px" fontWeight="600" color="#2F8133">
      Your goal check-in was successful
    </TextHeader1>
  </Box>
);

const SuccessCTA = ({
  onClickGoToGoals,
  onClickGoToCheckIn,
}: {
  onClickGoToCheckIn: Dispatch<SetStateAction<boolean>>;
  onClickGoToGoals: () => void;
}) => (
  <Box display="flex" justifyContent="center" alignItems="center" flex="1" width="100%" gap="16px">
    <Button variant="outline" onClick={() => onClickGoToCheckIn(false)}>
      Go to check-in
    </Button>
    <Button variant="filled" onClick={onClickGoToGoals}>
      Go to manage goals
    </Button>
  </Box>
);

export default function CheckInSuccessScreen({
  onClickGoToCheckIn,
  onClickGoToGoals,
}: {
  onClickGoToCheckIn: Dispatch<SetStateAction<boolean>>;
  onClickGoToGoals: () => void;
}) {
  return (
    <Box width="360px">
      <EmptyScreen
        headerComp={Heading}
        illustrationSrc={CheckInSuccessIllustration}
        // eslint-disable-next-line react/no-unstable-nested-components
        CTAComp={() => <SuccessCTA onClickGoToCheckIn={onClickGoToCheckIn} onClickGoToGoals={onClickGoToGoals} />}
        CTAContainerStyle={{ marginTop: '0px' }}
      />
    </Box>
  );
}
